// AddProduct.js
import { Fragment, useContext, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import { toast } from 'react-toastify';
import Sector from '../Dropdowns/Sector';
import Scheme from '../Dropdowns/Scheme';
import Batch from '../Dropdowns/Batch';
import SmartTc from '../Dropdowns/SmartTC';
import Centre from '../Dropdowns/Centre';
import axiosInstance from '../../axios'
import axios from 'axios'

export default function AddProduct({ addProductModalSetting, handlePageUpdate }) {
  const authContext = useContext(AuthContext);
  const [err, setErr] = useState(false);
  const [batch, setBatch] = useState('');
  const [centre, setCentre] = useState('');
  const [scheme, setScheme] = useState('');
  const [smart, setSmart] = useState('');
  const [view, setView] = useState(true);
  const[milestone,setMilestone]=useState('')
  const [status,setStatus]=useState('')
const imp=true
  let newDate = new Date();
  let date = newDate.getDate();
const [update,setUpdate]=useState(false)
const [disable,setDisable]=useState(false)
  const [invoice, setInvoice] = useState({
    invoice_no: '',
    milestone: '',
    gross_amount: 0,
    tds_amount: 0,
    penal_deduction: 0,
    created_date: 0,
    net_payment: 0,
    status: '',
    received_date: '',
    kit: 0,
    book: 0,
    centre_share: '',
    tds: ''
  });
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInvoice(prevState => ({
      ...prevState,
      [name]: value
    }))
  };
  const addinvoice = async () => {
    setDisable(true)
    try {
      const invoiceData = {
        invoice_no: invoice.invoice_no,
        milestone: milestone,
        gross_amount: invoice.gross_amount,
        tds_amount: invoice.tds_amount,
        penal_deduction: invoice.penal_deduction,
        created_date: invoice.created_date,
        net_payment: invoice.net_payment,
        status: status,
        kit: invoice.kit,
        book: invoice.book,
        centre_share: invoice.centre_share,
        tds: invoice.tds,
        batch_id: batch,
        scheme_id: scheme,
        centre_id: centre,
        smart_tc_id: smart,
        received_date: invoice.received_date || undefined
      };
    //  console.log(invoiceData)
  
      await axiosInstance.post('invoice/insert', invoiceData);
      
      toast.success('Invoice Added');
      setDisable(false)
      addProductModalSetting();
    } catch (err) {
      toast.error('Something went wrong')
      console.log(err);
    }
    handlePageUpdate();
  };
  
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Add Invoice
                      </Dialog.Title>
                      <form action="#" aria-autocomplete="true">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                          {/* Form Fields */}
                          {/* ... */}
                          <div>
                            <label htmlFor="invoice_no" className="block text-sm font-medium mb-2 text-gray-700">
                              Invoice Number <span className="text-red-600">*</span></label>
                            <input type="number"
                             name="invoice_no"
                              id="invoice_no" 
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                               value={invoice.invoice_no} 
                               onChange={handleInputChange} />
  </div>
  <div>
    <Centre value={centre} handleInputChange={(e)=>{setCentre(e.target.value); setUpdate(!update)}} imp={imp}/>
  </div>
  <div>
    <SmartTc value={centre} handleInputChange={e=>setSmart(e.target.value)} imp={imp}/>
  </div>
  <div>
    <Batch value={batch} handleInputChange={(e)=>{setBatch(e.target.value);setUpdate(!update)}} imp={imp} centre={centre}/>
  </div>
  <div>
    <Scheme value={scheme} handleInputChange={(e)=>{setScheme(e.target.value);setUpdate(!update)}}  centre={centre} imp={imp}/>
  </div>
  <div>
    <label htmlFor="milestone"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      Milestone  <span className='text-red-500'> *</span></label>
      <select
                id="batch-phase"
                value={milestone}
                onChange={e=>setMilestone(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>--Select--</option>
                <option value="Installment 1">Installment 1</option>
                <option value="Installment 2">Installment 2</option>
                <option value="Installment 3">Installment 3</option>
                <option value='Installment 4'>Installment 4</option>
                


            </select>
  </div>
  <div>
    <label htmlFor="status"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Status</label>
    <select
                id="status"
                value={status}
                onChange={e=>setStatus(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' disabled>--Select--</option>
                <option value="Invoice Raised">Invoice Raised</option>
                <option value="Invoice Paid">Invoice Paid</option>
                <option value="Invoice Unpaid">Invoice Unpaid</option>
                


            </select>
  </div>
  <div>
                              <label htmlFor="created_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Created Date  <span className='text-red-500'> *</span></label>
                            <input
                            type="date"
                            id="created_date"
                            name="created_date"
                            value={invoice.created_date}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   

                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="received_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Received Date </label>
                            <input
                            type="date"
                            id="received_date"
                            name="received_date"
                            value={invoice.received_date}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   

                            onChange={handleInputChange}
                            />

                            </div>
  

  <div>
    
    <label htmlFor="gross_amount"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      Gross Amount  <span className='text-red-500'> *</span></label>
    <input type="number" name="gross_amount" id="gross_amount"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.gross_amount} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="tds_amount"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      TDS Amount  <span className='text-red-500'> *</span></label>
    <input type="number" name="tds_amount" id="tds_amount"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.tds_amount} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="penal_deduction"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      Penal Deduction  <span className='text-red-500'> *</span></label>
    <input type="number" name="penal_deduction" id="penal_deduction"                                 
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.penal_deduction} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="net_payment"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      Net Payment  <span className='text-red-500'> *</span></label>
    <input type="number" name="net_payment" id="net_payment"                                  
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.net_payment} onChange={handleInputChange} />
  </div>

  <div>
  <label htmlFor="book"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Book  <span className='text-red-500'> *</span></label>
    <input type="number" name="book" id="book"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.book} onChange={handleInputChange} />
  </div>
  <div>
  <label htmlFor="kit"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Kit  <span className='text-red-500'> *</span></label>
    <input type="number" name="kit" id="kit"                                 
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.kit} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="centre_share"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      Centre Share  <span className='text-red-500'> *</span></label>
    <input type="number" name="centre_share" id="centre_share"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.centre_share} onChange={handleInputChange} />
  </div>
  <div>
  <label htmlFor="tds"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
  Centre TDS  <span className='text-red-500'> *</span></label>
    <input type="number" name="tds" id="tds"                                 
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.tds} onChange={handleInputChange} />
  </div>
  <div>
  <label htmlFor="tds"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
    After TDS  <span className='text-red-500'> *</span></label>
    <input type="text" name="tds" id="tds"   disabled                               
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
 value={invoice.centre_share - invoice.tds} />
  </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    disabled={disable}
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={addinvoice}
                  >
                    Add Invoice
                  </button>
                  <button
                    type="button"
                    
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => addProductModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
